// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-overlay {
    width: 70vw;
    height: 80vh;
    margin-top: 10vh;
    margin-left: 15vw;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.5rem;
    background: rgba(0, 0, 0, 0.5); /* Dim background for focus */
}

/* Container for the expanded image and title */
.expand-img-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 0.5rem;
    overflow: hidden;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);
}

/* Title bar */
.expand-img-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgb(13, 13, 48);
    color: white;
    padding: 1rem;
    font-size: 1rem;
    font-weight: bold;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    width: 100%; /* Ensure full width */
    white-space: nowrap; /* Prevents text wrapping */
}

/* Ensure title matches image width */
.expand-img-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Close button */
.popup-close-button {
    cursor: pointer;
    font-size: 1.5rem;
    transition: transform 0.2s ease-in-out;
}

.popup-close-button:hover {
    transform: scale(1.2);
}

/* Image container */
.expand-img-src-container {
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: 75vh; /* Prevents overflow */
    overflow: hidden;
}

/* Image styling */
.expand-img-src {
    max-width: 100%;
    max-height: 75vh;
    width: auto;
    height: auto;
    object-fit: contain;
}

/* Media query for tablets */
@media only screen and (max-width: 1024px) {
    .expand-img-container {
        max-width: 90vw;
    }
}

/* Media query for mobile screens */
@media only screen and (max-width: 768px) {
    .expand-img-container {
        max-width: 95vw;
    }
    
    .expand-img-title {
        font-size: 0.9rem;
        padding: 0.8rem;
    }

    .popup-close-button {
        font-size: 1.2rem;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/report/components/ReportImageExpand.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,8BAA8B,EAAE,6BAA6B;AACjE;;AAEA,+CAA+C;AAC/C;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA,cAAc;AACd;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iCAAiC;IACjC,YAAY;IACZ,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,+BAA+B;IAC/B,WAAW,EAAE,sBAAsB;IACnC,mBAAmB,EAAE,2BAA2B;AACpD;;AAEA,qCAAqC;AACrC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB,EAAE,sBAAsB;IACxC,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI;QACI,eAAe;IACnB;AACJ;;AAEA,mCAAmC;AACnC;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".popup-overlay {\n    width: 70vw;\n    height: 80vh;\n    margin-top: 10vh;\n    margin-left: 15vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.5rem;\n    background: rgba(0, 0, 0, 0.5); /* Dim background for focus */\n}\n\n/* Container for the expanded image and title */\n.expand-img-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: white;\n    border-radius: 0.5rem;\n    overflow: hidden;\n    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n/* Title bar */\n.expand-img-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: rgb(13, 13, 48);\n    color: white;\n    padding: 1rem;\n    font-size: 1rem;\n    font-weight: bold;\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n    width: 100%; /* Ensure full width */\n    white-space: nowrap; /* Prevents text wrapping */\n}\n\n/* Ensure title matches image width */\n.expand-img-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n/* Close button */\n.popup-close-button {\n    cursor: pointer;\n    font-size: 1.5rem;\n    transition: transform 0.2s ease-in-out;\n}\n\n.popup-close-button:hover {\n    transform: scale(1.2);\n}\n\n/* Image container */\n.expand-img-src-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    max-height: 75vh; /* Prevents overflow */\n    overflow: hidden;\n}\n\n/* Image styling */\n.expand-img-src {\n    max-width: 100%;\n    max-height: 75vh;\n    width: auto;\n    height: auto;\n    object-fit: contain;\n}\n\n/* Media query for tablets */\n@media only screen and (max-width: 1024px) {\n    .expand-img-container {\n        max-width: 90vw;\n    }\n}\n\n/* Media query for mobile screens */\n@media only screen and (max-width: 768px) {\n    .expand-img-container {\n        max-width: 95vw;\n    }\n    \n    .expand-img-title {\n        font-size: 0.9rem;\n        padding: 0.8rem;\n    }\n\n    .popup-close-button {\n        font-size: 1.2rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
